import { useState } from "react";
import type { SlotAvailability } from "../lib/types";
import { DAY_NAMES, RESOURCE_LABELS } from "../lib/types";
import { userCancelBooking } from "../lib/hooks";
import { Modal } from "./Modal";

interface CancelBookingPopupProps {
  slot: SlotAvailability;
  bookingGroupId: string;
  onClose: () => void;
  onCancelled: () => void;
}

export function CancelBookingPopup({ slot, bookingGroupId, onClose, onCancelled }: CancelBookingPopupProps) {
  const [confirming, setConfirming] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState<number | null>(null);

  const date = new Date(slot.date + "T00:00:00");
  const dayName = DAY_NAMES[date.getDay()];
  const dateStr = date.toLocaleDateString("sk-SK", {
    day: "numeric",
    month: "numeric",
    year: "numeric",
  });
  const timeStart = slot.start_time.slice(0, 5);
  const timeEnd = slot.end_time.slice(0, 5);
  const label = slot.title || RESOURCE_LABELS[slot.resource_type];

  const handleCancel = async () => {
    setLoading(true);
    setError("");
    const { data, error: err } = await userCancelBooking(bookingGroupId);
    setLoading(false);
    if (err) {
      setError(err.message);
      setConfirming(false);
      return;
    }
    const creditCents = typeof data === "object" && data !== null ? (data as any).refund_credit_cents ?? 0 : 0;
    setSuccess(creditCents);
    setTimeout(() => {
      onCancelled();
      onClose();
    }, 2000);
  };

  return (
    <Modal>
      <div className="popup-overlay" onClick={onClose}>
        <div className="popup" onClick={(e) => e.stopPropagation()}>
          <div className="popup-head">
            <span className="popup-eyebrow popup-eyebrow-mine">Vaša rezervácia</span>
            <h3>{label}</h3>
            <span className="popup-sub">{dayName}, {dateStr}</span>
          </div>

          <dl className="popup-grid">
            <dt>Čas</dt>
            <dd>{timeStart} – {timeEnd}</dd>
          </dl>

          {error && <div className="form-error">{error}</div>}

          {success !== null ? (
            <div className="credit-notification" style={{ padding: "12px 0", textAlign: "center" }}>
              Rezervácia zrušená.{" "}
              {success > 0
                ? `Kredit +${(success / 100).toFixed(2).replace(".", ",")} € pripísaný`
                : ""}
            </div>
          ) : (
            <div className="popup-actions">
              <button className="btn btn-secondary" onClick={onClose}>
                Zavrieť
              </button>
              {!confirming ? (
                <button className="btn btn-danger" onClick={() => setConfirming(true)}>
                  Zrušiť rezerváciu
                </button>
              ) : (
                <button className="btn btn-danger" onClick={handleCancel} disabled={loading}>
                  {loading ? "Ruším..." : "Potvrdiť zrušenie"}
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
}
